import { CountdownPosition } from '@/types';

export const COUNTDOWN_POSITION_CLASS: Record<CountdownPosition, string> = {
	[CountdownPosition.RIGHT_OF_TITLE]: 'countdown-position-right',
	[CountdownPosition.LEFT_OF_TITLE]: 'countdown-position-left',
	[CountdownPosition.ABOVE_TITLE]: 'countdown-position-above',
	[CountdownPosition.BELOW_TITLE]: 'countdown-position-below',
};

export function getCountdownPositionClass(position?: CountdownPosition): string {
	return (
		COUNTDOWN_POSITION_CLASS[position ?? CountdownPosition.RIGHT_OF_TITLE] ??
		COUNTDOWN_POSITION_CLASS[CountdownPosition.RIGHT_OF_TITLE]
	);
}
